import { bus } from '@/utility';
import store from '@/store';

const setListener = (pusher) => {
  const {
    platform,
    config,
  } = store.getters;
  const channel = pusher.subscribe(`NSoft.Seven.${config.gateway.slaveId}.Device.${platform.deviceUuid}`);

  channel.bind('TicketUpdate', (data) => {
    bus.$emit('ticketUpdate', data);
  });
};

export default {
  init() {
    const pusher = new Pusher(`${process.env.VUE_APP_PUSHER_KEY}`, {
      cluster: 'eu',
      forceTLS: true,
    });
    setListener(pusher);
  },
};
